/**
 * MODULE: ToastContainer — mounts provider + toast list (**`useToast`** lives in **`toastContext`**)
 * RECENT: 2026-04-26 — **`z-[100]`** so toasts stack above **`AiAssistantPanel`** (`z-50`) and thread menu (`z-[60]`).
 */

import { useCallback, useMemo, useState } from 'react';
import { ToastContext } from './toastContext';
import { Toast } from './Toast';
import type { Toast as ToastModel, ToastContainerProps } from './toast.types';

export function ToastContainer({ children }: ToastContainerProps) {
  const [toasts, setToasts] = useState<ToastModel[]>([]);

  const showToast = useCallback((toast: Omit<ToastModel, 'id'>) => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    setToasts((prev) => [...prev, { ...toast, id }]);
  }, []);

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const contextValue = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div className="fixed top-4 right-4 z-[100] w-full max-w-sm">
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onDismiss={dismissToast} />
        ))}
      </div>
    </ToastContext.Provider>
  );
}
